import {injectable} from '@gongxigames/framework/core/installer';
import {ICommandLineInterface} from '@gongxigames/framework/core/types';

type Command = Function | Record<string, Function>;

@injectable()
export class CommandLineInterface {
    protected commands: Record<string, Command> = {};
    protected CLInterfaces: ICommandLineInterface[] = [];

    public addInterface(cli: ICommandLineInterface): CommandLineInterface {
        for (const name in this.commands) {
            if (this.commands.hasOwnProperty(name)) {
                cli.addCommand(name, this.commands[name]);
            }
        }

        this.CLInterfaces.push(cli);

        return this;
    }

    public addCommand(name: string, command: Command): CommandLineInterface {
        this.commands[name] = command;

        this.CLInterfaces.forEach(cli => cli.addCommand(name, command));

        return this;
    }

    public getCommand(name: string): Command | undefined {
        return this.commands[name];
    }

    public clear(): void {
        for (const name in this.commands) {
            if (this.commands.hasOwnProperty(name)) {
                this.CLInterfaces.forEach(cli => cli.removeCommand(name));
            }
        }

        this.CLInterfaces.length = 0;
        this.commands = {};
    }
}
